import apiService from '@/services/apiService';

const actions = {
  getGlobalSearchWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('global-search/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getContentTypes({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('global-search/find-all-content-type')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getGlobalSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`global-search/find-by-id/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postGlobalSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('global-search', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putGlobalSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`global-search/update/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteGlobalSearch({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`global-search/delete/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
};

export default actions;